var interval = setInterval(function(){
    if(document.getElementsByClassName('loox-float-toggler-container').length > 0 && window.matchMedia('screen and (max-width: 550px)').matches) {
      console.log("elem find")
        document.getElementsByClassName('loox-float-toggler-container')[0].remove()
       clearInterval(interval);
    }
  }, 50);


var secinter = setInterval(function(){
    if(document.getElementsByClassName('loox-pn loox-pn--shown').length > 0 && window.matchMedia('screen and (max-width: 550px)').matches) {
      console.log("sec elem find")
        document.getElementsByClassName('loox-pn loox-pn--shown')[0].remove()
       clearInterval(secinter);
    }
  }, 50);

